export default __webpack_public_path__ + "static/media/cpu.cbfa0edf.svg";